import React from 'react'
import { useNavigate } from 'react-router-dom'
import './MobileAction.css'

const MobileAction = ({ icon, topName, bottomName, link }) => {
    const navigate = useNavigate();
    
    const handleClick = () => {
        navigate(link);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            navigate(link);
        }
    };

    return (
        <div 
            className='mobile-action' 
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            role="button"
            aria-label={`Navigate to ${topName} ${bottomName}`}
        >
            <div className='mobile-action-icon'>{icon}</div>
            <div className='mobile-action-top-name'>{topName}</div>
            <div className='mobile-action-bottom-name'>{bottomName}</div>
        </div>
    );
}

export default MobileAction